import { useWorkspaceAgentElicitationTracking } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useWorkspaceAgentElicitationTracking';
import { type AskFormElicitation } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/isAskFormElicitationEntry';

type UseTrackWorkspaceAgentFormChoiceCounts = {
  fieldCount?: number;
  optionCount?: number;
};

export const useTrackWorkspaceAgentFormChoice = (
  elicitation: AskFormElicitation,
  counts?: UseTrackWorkspaceAgentFormChoiceCounts,
) =>
  useWorkspaceAgentElicitationTracking({
    createdAt: elicitation.createdAt,
    elicitationId: elicitation.id,
    elicitationType: elicitation.type,
    fieldCount: counts?.fieldCount,
    optionCount: counts?.optionCount,
  });
